<template>
  <div class="bg1" ref="setH">
    <div class="manageBox">
      <div class="searchBox">
        <el-form ref="form" :model="search" label-width="120px" size="small">
          <el-form-item label="学校："
            ><el-select
              v-model="search.schoolId"
              placeholder="选择学校"
              size="small"
              clearable
            >
              <el-option
                v-for="item in conditions.xuexiaoList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option> </el-select
          ></el-form-item>
          <el-form-item label="年级："
            ><el-select
              v-model="search.gradeId"
              placeholder="选择年级"
              size="small"
              clearable
            >
              <el-option
                v-for="item in conditions.nianjiList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option> </el-select
          ></el-form-item>
          <el-form-item label="姓名：">
            <el-input
              v-model="search.userName"
              style="width: 215px"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-date-picker
              v-model="search.beginDate"
              :picker-options="pickerOptionsStart"
              size="small"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 150px"
              placeholder="选择开始日期"
            >
            </el-date-picker>
            <font style="padding: 0 10px">至</font>
            <el-date-picker
              v-model="search.endDate"
              :picker-options="pickerOptionsEnd"
              size="small"
              style="width: 150px"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            ><el-button type="primary" @click="getDataList" size="small"
              >查询</el-button
            >
            <el-button type="primary" @click="daochu" size="small"
              >导出</el-button
            >
            <el-button @click="clear" size="small"
              >重置</el-button
            ></el-form-item
          >
        </el-form>
      </div>

      <div class="contentBox">
        <div
          style="
            background-color: #edf5ff;
            line-height: 40px;
            float: right;
            padding: 0 15px;
            color: #444;
          "
        >
          合计 | 共享数<span
            style="color: #0096ff; padding: 0 4px; font-weight: bold"
            >{{ numAndPage.shareCount }}</span
          >，浏览数<span
            style="color: #0096ff; padding: 0 4px; font-weight: bold"
            >{{ numAndPage.visitedSum }}</span
          >，收藏数<span
            style="color: #0096ff; padding: 0 4px; font-weight: bold"
            >{{ numAndPage.favoriteSum }}</span
          >，下载数<span
            style="color: #0096ff; padding: 0 4px; font-weight: bold"
            >{{ numAndPage.downloadSum }}</span
          >
        </div>
        <el-table
          stripe
          :data="tableData"
          style="width: 100%"
          @sort-change="sort"
        >
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="userName" label="姓名"></el-table-column>
          <el-table-column prop="schoolName" label="校区"></el-table-column>
          <el-table-column prop="gradeName" label="年级"></el-table-column>
          <el-table-column
            prop="shareCount"
            sortable="custom"
            label="共享量"
          ></el-table-column>
          <el-table-column
            prop="visitedSum"
            sortable="custom"
            label="被浏览量"
          ></el-table-column>
          <el-table-column
            prop="favoriteSum"
            sortable="custom"
            label="被收藏量"
          ></el-table-column>
          <el-table-column
            prop="downloadSum"
            sortable
            label="被下载量"
          ></el-table-column>
        </el-table>
        <div class="pages">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pages.pageAll"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fileDownload from "js-file-download";
import Axios from "axios";
export default {
  name: "statisticsPeople",
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.search.endDate) {
            return time.getTime() > new Date(this.search.endDate).getTime();
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.search.beginDate) {
            return (
              time.getTime() <
              new Date(this.search.beginDate).getTime() - 86400000
            );
          }
        },
      },
      ccc: "按照个人统计",
      search: {
        schoolId: "",
        beginDate: "",
        endDate: "",
        userName: "",
        page: 1,
        size: 10,
        sectionId: "",
        gradeId: "",
        sortString: "",
      },
      tableData: [],
      pages: {
        pageIndex: 1,
        pageAll: 100,
        pageSize: 10,
      },
      conditions: {
        xuexiaoList: [],
        xueduanList: [],
        nianjiList: [],
      },
      tabH: 0,
      numAndPage: { filePage: 0, printNumber: 0 },
    };
  },
  watch: {
    "search.schoolId": {
      handler(v) {
        if (v) {
          this.search.gradeId = "";
          this.conditions.nianjiList = [];
          this.getNianJi();
        } else {
          this.search.gradeId = "";
          this.conditions.nianjiList = [];
        }
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.tabH = this.$refs.setH.clientHeight - 160;
    });
    this.getSchoolList();
    this.getXueDuan();
    this.getDataList();
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        } else if (index === 1) {
          sums[index] = "";
          return;
        } else if (index === 2) {
          sums[index] = "";
          return;
        } else if (index === 3) {
          sums[index] = "";
          return;
        } else {
          const values = data.map((item) => Number(item[column.property]));
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
      });
      return sums;
    },
    sort({ column, prop, order }) {
      let o =
        order == "ascending" ? "asc" : order == "descending" ? "desc" : "asc";
      this.search.sortString = prop + " " + o;
      this.getDataList();
    },
    // 获取学校列表
    getSchoolList() {
      let urlLink = `/common/load/school`;
      let param = {};
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取学校", res);
        this.conditions.xuexiaoList = res;
      });
    },
    //清空查询条件
    clear() {
      this.search.beginDate = "";
      this.search.endDate = "";
      this.search.schoolId = "";
      this.search.sectionId = "";
      this.search.gradeId = "";
    },
    // 获取学段
    getXueDuan() {
      let urlLink = `/common/catalog/load/section`;
      this.$ajax.post(urlLink).then((res) => {
        console.log("获取学段", res);
        this.conditions.xueduanList = res;
      });
    },
    // 获取年级
    getNianJi() {
      let urlLink = `/common/load/school/grade`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取年级", res);
        this.conditions.nianjiList = res;
      });
    },
    // 获取统计列表
    getDataList() {
      let urlLink = `/server/resource/stat/statByUser`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取统计列表", res);
        this.tableData = res.list;
        this.pages.pageAll = res.total;
      });
      this.$ajax
        .post("/server/resource/stat/statByPersonTotal", param)
        .then((res) => {
          this.numAndPage = res ? res : { filePage: 0, printNumber: 0 };
        });
    },
    // 分页页码变动
    handleSizeChange(v) {
      this.search.size = v;
      this.search.page = 1;
      this.getDataList();
    },
    handleCurrentChange(v) {
      this.search.page = v;
      this.getDataList();
    },
    // 导出
    daochu() {
      let param = this.search;
      var requestUrl = "/server/resource/stat/export/statByUser";
      Axios({
        method: "post",
        url: requestUrl,
        data: param,
        responseType: "blob",
      })
        .then((res) => {
          fileDownload(res.data, "按个人统计.xlsx");
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/statistics/people.vue